export default __webpack_public_path__ + "static/media/orangeWarningIcon.79ca08b1.svg";